<script lang="ts">
  import { Button, Col, Container, Input, Row } from "sveltestrap";
  import BookmarkClipBoard from "./BookmarkClipBoard.svelte";
  import Card from "../../../Core/Card.svelte";
  import { ClipboardOnTextInput, Copy, Cut, Cutcopyfromtextinput } from "../../../../utils/Constant/Constant";
  import { copy } from 'svelte-copy';
  import ClipBoardSub from "./ClipBoardSub.svelte";
  import ClipboardOnTextArea from "./ClipboardOnTextArea.svelte";
  let newValue:string = ""
  let newText:string = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has"
  function handleValue(){
    newValue = ""
  }
  function handleValue1(){
    newText = ""
  }

</script>
<BookmarkClipBoard />
<Container fluid>
    <Row>
      <Col sm="12" md="6">
        <Card headerTitle={ClipboardOnTextInput} cardHeaderprops="pb-0">
          <div slot="contentbody">
            <div class="clipboaard-container">
              <p class="card-description">{Cutcopyfromtextinput}</p>
              <Input id="clipboardExample1" type="text" bind:value={newValue} placeholder="type some text to copy / cut" />
              <div class="mt-3">
                <button class="btn btn-primary btn-clipboard" use:copy={newValue}>
                  <i class="fa fa-copy"></i> {Copy}
                </button>
                <Button color="secondary" on:click={handleValue} class="btn-clipboard-cut" >
                    <i class="fa fa-cut"></i> {Cut}
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </Col>
      <ClipboardOnTextArea />
      <ClipBoardSub />
    </Row>
</Container>